import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ItemHdrQueryCriteriaClass, ItemHdrCriteriaModelQuery } from '../../../criteria/item-hdr-criteria.model';
import { BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { FinancialItemContainerModel, FinancialItemImageHdrContainer, FinancialItemLineModel, FinancialItemQueryCriteria, FinancialItemStockBalanceContainerModel } from '../../../../../../models/aggregates/erp/financial';
import { bl_fi_mst_item_ext_RowClass } from "../../../../../../models/dbschema";
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { Optional } from 'typescript-optional';
import { Pagination } from '../../shared';
import { FinancialItemSearchCriteriaDtoModel } from '../../../data-transfer-objects';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class FinancialItemService extends BaseApiPublicLoginTemplateService<FinancialItemContainerModel, FinancialItemContainerModel, FinancialItemContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items';
    this.endpoint_path_website_ep_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/' + BaseApiTemplateService.WEBSITE_EP;
    this.httpClient = http;
  }

  public postByCriteriaPromise(queryCriteria: FinancialItemQueryCriteria, visa: ApiVisa):
    Promise<PagingResponseModel<FinancialItemContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + queryCriteria;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.post<PagingResponseModel<FinancialItemContainerModel>>(
      this.apiUrl + '/query',
      queryCriteria,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: ItemHdrQueryCriteriaClass
  ): Promise<PagingResponseModel<FinancialItemContainerModel>> {
    const buildDocCriteria = new ItemHdrCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<PagingResponseModel<FinancialItemContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getByLine(
    visa: ApiVisa, line: string
  ){
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
    }
    const UrlByCriteria = this.apiUrl + '/lines/' + line;
    return this.httpClient.get<BasicApiResponseModel<FinancialItemLineModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  getByLinePromise(
    visa: ApiVisa, line: string
  ): Promise<BasicApiResponseModel<FinancialItemLineModel>>{
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}`;
    }
    const UrlByCriteria = this.apiUrl + '/lines/' + line;
    return this.httpClient.get<BasicApiResponseModel<FinancialItemLineModel>>(UrlByCriteria, this.getHttpHeader(visa)).toPromise();
  }

  getObservaleByCriteria(
    visa: ApiVisa, criteria?: ItemHdrQueryCriteriaClass
  ): Observable<PagingResponseModel<FinancialItemContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildDocCriteria = new ItemHdrCriteriaModelQuery(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    //  const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query + ' offset ' + buildDocCriteria.voucherHdrCriteria.offset * buildDocCriteria.voucherHdrCriteria.limit + ' limit ' + buildDocCriteria.voucherHdrCriteria.limit;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<PagingResponseModel<FinancialItemContainerModel>>
      (UrlByCriteria, this.getHttpHeader(visa));
  }

  getByCriteriaHdr(pagination: Pagination, visa: ApiVisa):
    Observable<PagingResponseModel<FinancialItemContainerModel>> {
    let url = this.apiUrl + '/headers/' + 'query?' + pagination.getQueryKeyValues();
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/headers/' + 'query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<FinancialItemContainerModel>>
      (url, this.getHttpHeader(visa));
  }

  getByCriteriaLine(pagination: Pagination, visa: ApiVisa):
  Observable<PagingResponseModel<FinancialItemLineModel>> {
    let url = this.apiUrl + '/lines/' + 'query?' + pagination.getQueryKeyValues();
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/lines/' + 'query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<FinancialItemLineModel>>
      (url, this.getHttpHeader(visa));
  }

  public postItemPromise(
    dtoObject: FinancialItemContainerModel, visa: ApiVisa
  ): Promise<BasicApiResponseModel<FinancialItemContainerModel>> {
    return this.httpClient.post<BasicApiResponseModel<FinancialItemContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  public postItem(dtoObject: FinancialItemContainerModel, visa: ApiVisa
  ): Observable<BasicApiResponseModel<FinancialItemContainerModel>> {
    return this.httpClient.post<BasicApiResponseModel<FinancialItemContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public editItemPromise(dtoObject: FinancialItemContainerModel, visa: ApiVisa
  ): Promise<BasicApiResponseModel<FinancialItemContainerModel>> {
    return this.httpClient.put<BasicApiResponseModel<FinancialItemContainerModel>>(
      this.apiUrl, dtoObject, this.getHttpHeader(visa))
      .toPromise();
  }

  updateImageAndDetails(formData: FormData, imageGuid, httpOptions) {
    const url = this.apiUrl + '/replace-file/' + imageGuid;
    return this.httpClient.put(url, formData, httpOptions);
  }

  replaceImageAndDetails(formData: FormData, imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-file/' + imageGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImageAndDetails(formData: FormData, subjectGuid, httpOptions) {
    const url = this.apiUrl + '/add-files/' + subjectGuid;
    return this.httpClient.post(url, formData, httpOptions);
  }

  addImageAndDetails(formData: FormData, subjectGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-files/' + subjectGuid;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  addImageAndDetailsIsPublic(formData: FormData, subjectGuid, imagepublic, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-files/' + subjectGuid + '?is_public=' + imagepublic;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  uploadImageAndDetailsPromise(formData: FormData, subjectGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-files/' + subjectGuid;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa)).toPromise();
  }

  uploadImageAndDetailsIsPublicPromise(formData: FormData, subjectGuid, imagepublic, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-files/' + subjectGuid + '?is_public=' + imagepublic;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa)).toPromise();
  }

  replaceImageAndDetailsIsPublic(formData: FormData, imageGuid, imagepublic, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-file/' + imageGuid + '?is_public=' + imagepublic;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  updateImageDetails(imageItemDetail: bl_fi_mst_item_ext_RowClass, httpOptions) {
    const url = this.apiUrl + '/extensions';
    return this.httpClient.put(url, imageItemDetail, httpOptions);
  }

  updateImageDetailExt(imageItemDetail: bl_fi_mst_item_ext_RowClass, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/extensions';
    return this.httpClient.put(url, imageItemDetail, this.getHttpHeader(visa));
  }

  getExtDetails(imageGuid, httpOptions) {
    const url = this.apiUrl + '/extensions/' + imageGuid;
    return this.httpClient.get(url, httpOptions);
  }

  getExtImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/extensions/' + imageGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  getImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + imageGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  public getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + extGuid;

    return this.httpClient.get<Blob>(
      url,
      {
        headers: new HttpHeaders({
          authorization: visa.jwt_secret,
          responseType: 'blob',
          tenantCode: visa.tenantCode
        }),
        responseType: 'blob' as 'json'
      });
  }

  static filesToFormData(files: File[], formDataKeyValue: Optional<string>): FormData {
    let formData = new FormData();
    if (!files || files.length === 0) return formData;
    files.forEach(file => formData.append(formDataKeyValue.orElse('files'), file));
    return formData;
  }
  private static fileToFormData(file: File, formDataKeyValue: Optional<string>): FormData {
    return FinancialItemService.filesToFormData([file], formDataKeyValue);
  }

  replaceFile(file: File, fileExtGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<FinancialItemContainerModel>> {
    let formData = FinancialItemService.fileToFormData(file, Optional.of('file'));
    const url = this.apiUrl + '/replace-file/' + fileExtGuid;
    return this.httpClient.put<BasicApiResponseModel<FinancialItemContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  addFile(files: File[], hdrGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<FinancialItemContainerModel>> {
    let formData = FinancialItemService.filesToFormData(files, Optional.of('file'));
    const url = this.apiUrl + '/add-files/' + hdrGuid;
    return this.httpClient.put<BasicApiResponseModel<FinancialItemContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  postImageHdr(dtoObject: FinancialItemImageHdrContainer, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/images';
    return this.httpClient.post<BasicApiResponseModel<FinancialItemImageHdrContainer>>(
      this.url, dtoObject, this.getHttpHeader(visa)
    );
  }

  postImageHdrPublic(dtoObject: FinancialItemImageHdrContainer, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/public-ep/images';
    return this.httpClient.post<BasicApiResponseModel<FinancialItemImageHdrContainer>>(
      this.url, dtoObject, this.getHttpHeader(visa)
    );
  }

  addImageHdrIsPublic(formData: FormData, hdrGuid: string, visa: ApiVisa, imagepublic: boolean = false) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-images/' + hdrGuid + '?is_public=' + imagepublic;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  replaceImageHdrIsPublic(formData: FormData, extGuid: string, visa: ApiVisa, imagepublic: boolean = false) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-images/' + extGuid + '?is_public=' + imagepublic;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getImageHdrItemFile(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/image-file/' + imageHdrGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  getImageHdrItemFilePublic(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/pub/image-file/' + imageHdrGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  deleteImageHdrItemFile(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/image-file/' + imageHdrGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  deleteMultipleImageHdrItem(imageHdrGuids: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/image-files/' + imageHdrGuids;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  getDataByPost(
    dtoObject,
    visa: ApiVisa
    ): Observable<BasicApiResponseModel<any>>{
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/query"

      return this.httpClient.post<BasicApiResponseModel<any>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
  }

  convertBasicToBundle(dtoObject: FinancialItemContainerModel, childGuids: string[], visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/update-bundle/backoffice-ep/' + childGuids.join(',');
    return this.httpClient.put(url, dtoObject, this.getHttpHeader(visa));
  }

  public getFiItemsBySnapshotCustomQuery(dtoObject: FinancialItemSearchCriteriaDtoModel, visa: ApiVisa): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/backoffice-ep/custom/query/snapshot';
    return this.httpClient.post<PagingResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaStockBalance(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<FinancialItemStockBalanceContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/stock-balance/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<FinancialItemStockBalanceContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getVerificationAndDelete(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/verify-guid-for-deletion/backoffice-ep/${guid}`;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      customUrl,
      this.getHttpHeader(visa)
    );
  }

  createGroupItemWithAttributes(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/create-group-item-with-attributes/backoffice-ep';
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
  
  updateGroupItemWithAttributes(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/update-group-item-with-attributes/backoffice-ep';
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
